// extracted by mini-css-extract-plugin
export default {"confirmationWord":"LibraryDeleteModal-module__confirmationWord_fXz_G","input":"LibraryDeleteModal-module__input_nmxX2","detachNotice":"LibraryDeleteModal-module__detachNotice_gvpnS"};